import React from "react";

const PersonalInfoStep = ({ formData, onChange }) => (
  <div>
    <h3 className="font-playfair text-2xl font-bold text-gray-900 mb-2">
      Vos informations
    </h3>
    <p className="text-gray-500 text-sm mb-8">Dites-nous comment vous contacter</p>
    <div className="space-y-5">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1.5">
          Nom complet <span className="text-[#E5007D]">*</span>
        </label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={onChange}
          required
          className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#E5007D]/30 focus:border-[#E5007D] transition-all bg-white text-sm"
          placeholder="Votre nom complet"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">
            Email <span className="text-[#E5007D]">*</span>
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={onChange}
            required
            className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#E5007D]/30 focus:border-[#E5007D] transition-all bg-white text-sm"
            placeholder="votre@email.com"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">
            Téléphone <span className="text-[#E5007D]">*</span>
          </label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={onChange}
            required
            className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#E5007D]/30 focus:border-[#E5007D] transition-all bg-white text-sm"
            placeholder="Ex. : 06 12 34 56 78"
          />
        </div>
      </div>
    </div>
  </div>
);

export default PersonalInfoStep;
